module.exports = __webpack_public_path__ + "static/media/card-logo-8.7afdb823.svg";